"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleMark = void 0;
const slate_1 = require("slate");
const is_mark_active_1 = require("./is-mark-active");
exports.toggleMark = (editor, format) => {
    const isActive = is_mark_active_1.isMarkActive(editor, format);
    if (isActive) {
        slate_1.Editor.removeMark(editor, format);
    }
    else {
        slate_1.Editor.addMark(editor, format, true);
    }
};
//# sourceMappingURL=toggle-mark.js.map